// React is imported automatically by Vite
import DynamicDashboard from './components/DynamicDashboard'

function App() {
  return (
    <div className="App">
      <DynamicDashboard />
    </div>
  )
}

export default App